import React from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import { PageHero } from "../components";
import { addToCart, clearCart, removeFromCart } from "../actions";
import { Link } from "react-router-dom";
import { currency } from "../helper";

const Cart = () => {
  const { totalPrice, totalProducts, cartProducts } = useSelector(
    (state) => state.cart
  );
  const { loggedIn, userName } = useSelector((state) => state.user);
  const dispatch = useDispatch();

  return (
    <>
      <PageHero title="cart"></PageHero>
      {totalProducts == 0 ? (
        <EmptyCart>
          <h1>Your cart is empty</h1>
          <Link to="/products">
            <button className="btn">Continue Shopping</button>
          </Link>
        </EmptyCart>
      ) : (
        <>
          <Checkout>
            <h3>{loggedIn ? "Welcome, " + userName : "Sign in to checkout"}</h3>
            <table>
              <tbody>
                <tr>
                  <td>Subtotal</td>
                  <td>:</td>
                  <td>
                    {currency} {totalPrice}
                  </td>
                </tr>
                <tr>
                  <td>Shipping charges</td>
                  <td>:</td>
                  <td>{currency} 4.00</td>
                </tr>

                <tr>
                  <td>Order Total</td>
                  <td>:</td>
                  <td>
                    {currency} {totalPrice + 4}
                  </td>
                </tr>
              </tbody>
            </table>
            {loggedIn ? (
              <Link to="/">
                <button
                  onClick={() => {
                    dispatch(clearCart());
                  }}
                  className="btn"
                >
                  CHECKOUT
                </button>
              </Link>
            ) : (
              <Link to="/login">
                <button className="btn">SIGN IN</button>
              </Link>
            )}
          </Checkout>
          <CartItems>
            {cartProducts.map((product) => (
              <div className="item" key={product._id}>
                <div className="info">
                  <div className="img">
                    <img src={product.image} alt="" />
                  </div>
                  <div className="about">
                    <h2>{product.name.toLowerCase()}</h2>
                    <h3>
                      {currency} {product.price}
                    </h3>
                  </div>
                </div>
                <div className="counter">
                  <button onClick={() => dispatch(addToCart(product))}>
                    +
                  </button>
                  <h3>{product.count}</h3>
                  <button onClick={() => dispatch(removeFromCart(product))}>
                    -
                  </button>
                </div>
              </div>
            ))}
            <div className="clear-cart">
              <Link to="/products">
                <button className="btn continue-shopping">
                  CONTINUE SHOPPING
                </button>
              </Link>
              <button className="btn" onClick={() => dispatch(clearCart())}>
                CLEAR CART
              </button>
            </div>
          </CartItems>
        </>
      )}
    </>
  );
};

const CartItems = styled.section`
  width: 80vw;
  margin: 2em auto;
  border-top: 1px solid var(--color-black-3);

  > .clear-cart {
    margin: 20px 0;
    display: flex;
    justify-content: space-between;
    .continue-shopping {
      margin-right: 20px;
    }
  }
  > .item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 30px 0;
    border-bottom: 1px solid var(--color-black-3);
    > .info {
      display: flex;
      align-items: center;
      > .img {
        > img {
          height: 100px;
          width: 100px;
          object-fit: cover;
          border-radius: 5px;
        }
      }
      > .about {
        margin-left: 10px;
        > h2 {
          text-transform: capitalize;
        }
        > h3 {
          font-weight: 600;
          color: var(--color-primary-1);
        }
      }
    }
  }
  .counter {
    display: flex;
    flex-direction: column;
    font-size: 1.5em;
    text-align: center;
    /* border: 1px solid var(--color-primary-4); */
    border-radius: 10px;
    overflow: hidden;
    > button {
      width: 100%;
      border: none;
      font-size: 1em;
      padding: 2px 8px;
      background-color: var(--color-primary-1);
      cursor: pointer;
      color: var(--color-white);
    }
    h3 {
      background-color: var(--color-secondary-1);
      padding: 0 5px;
    }
  }

  @media screen and (max-width: 500px) {
    > .item {
      > .info {
        .img {
          img {
            width: 80px;
            height: 80px;
          }
        }
      }
    }
  }
`;

const Checkout = styled.section`
  width: max-content;
  margin: 20px auto;
  margin-left: 10vw;
  > h3 {
    text-transform: capitalize;
  }
  > a > button {
    width: 100%;
  }
  > table {
    border: 1px solid var(--color-black-3);
    padding: 1.5em 2.5em;
    margin: 20px 0;
    > tbody {
      > tr {
        > td {
          :nth-child(3n-1) {
            padding: 0 30px;
          }
        }
        :nth-child(1) {
          font-size: 1.2em;
          font-weight: 600;
          > td {
            padding-bottom: 0.5em;
          }
        }
        :nth-child(2) {
          > td {
            padding-bottom: 1em;
            border-bottom: 1px solid var(--color-black-3);
          }
        }
        :nth-child(3) {
          font-size: 1.5em;
          font-weight: 700;
          > td {
            padding-top: 0.5em;
          }
        }
      }
    }
  }
  @media screen and (max-width: 500px) {
    width: 90vw;
    margin: 20px auto;
    > table {
      width: 100%;
    }
  }
`;

const EmptyCart = styled.section`
  margin: 10vh auto;
  text-align: center;
  > h1 {
    font-size: 2.5em;
    margin-bottom: 20px;
  }
`;

export default Cart;
